// src/api/photoApi.js
import axios from 'axios';

const api = axios.create({ baseURL: 'http://localhost:8001' });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('idToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

/* ------------------------------------------------------------------
 * Existing helpers (unchanged except labelPhoto adds orientation)
 * ---------------------------------------------------------------- */
export const getPhotos = async () => {
  const response = await api.get('/api/photos/unlabeled');
  return response.data;
};

export const removePhoto = async (photoId) => {
  await api.post(`/api/photos/${photoId}/remove`, {
    username: localStorage.getItem('username'),
  });
};

export const labelPhoto = async (
  photoId,
  label,
  manufacturer,
  shingleType,
  color,
  orientation = 0,        // NEW default orientation
) => {
  await api.post(`/api/photos/${photoId}/label`, {
    label,
    manufacturer,
    shingle_type: shingleType,
    color,
    orientation,          // pass through to backend
  });
};

export const getLabelLog = async (photoId) => {
  const response = await api.get(`/api/photos/${photoId}/log`);
  return response.data;
};

export const getAlertPhotos = async () => {
  const response = await api.get('/api/photos/alert');
  return response.data;
};
